import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {IconModel} from '../../../../api/src/icon/icon.model';
import {environment} from '../../../../../src/environments/environment';
import {CalcparamstateiconModel} from '../../../../api/src/calcparamstateicon/calcparamstateicon.model';
import {DeviceparamstateiconModel} from '../../../../api/src/deviceparamstateicon/deviceparamstateicon.model';
import {CalcparamModel} from '../../../../api/src/calcparam/calcparam.model';
import {DeviceparamModel} from '../../../../api/src/deviceparam/deviceparam.model';
import {ParamstateModel} from '../../../../api/src/paramstate/paramstate.model';
import _ from 'lodash';
import {TreeTableService} from 'primeng/treetable';

@Component({
    selector: 'in-icon-picklist-form',
    templateUrl: './icon-picklist-form.component.html',
    styleUrls: ['./icon-picklist-form.component.scss'],
    providers: [TreeTableService],
    standalone: false
})
export class IconPicklistFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() pageTitle = '';
  @Input() cdparam: CalcparamModel | DeviceparamModel;
  @Input() iconsets: any[];
  @Input() icons: IconModel[] = [];
  @Input() assignedIcons: { [key: string]: IconModel } = {};
  @Input() paramstates: ParamstateModel[] = [];
  @Input() deviceparamstateicons?: (CalcparamstateiconModel | DeviceparamstateiconModel)[] = [];
  @Input() maxlength = 50;
  @Output() save = new EventEmitter<any>();
  log = console.log;
  deviceParamStateIconInfoList: (CalcparamstateiconModel | DeviceparamstateiconModel)[] = [];

  bodyTemplate: TemplateRef<any>;
  calendarLocale;

  draggedIcon: IconModel;
  values: any[] = [];
  isSave = false;
  isSaved = false;
  isCancel = false;

  statefieldname: {[key: string]: string} = {'-1': 'undefined', 0: 'not_controlled', 1: 'ok', 2: 'difference', 3: 'critical'};

  @ViewChild('iconsettree', {static: false}) treeComponent;

  constructor(private cdr: ChangeDetectorRef,private tt: TreeTableService) {
  }

  ngOnInit() {
    this.deviceParamStateIconInfoList = _.cloneDeep(this.deviceparamstateicons);
  }

  ngOnDestroy() {
    return;
  }

  ngOnChanges() {
    this.deviceParamStateIconInfoList = _.cloneDeep(this.deviceparamstateicons);
  }

  onSave() {
    this.isSave = false;
    this.isCancel = false;
    this.values = [];
    this.deviceParamStateIconInfoList.forEach(_state => {
      const isChanged = true;
      this.values.push(_state);
    });
    this.save.next(this.deviceParamStateIconInfoList);
    this.isSaved = true;
  }

  delete(deviceparamstateinfo, index) {
    if (index > -1) {
      this.deviceParamStateIconInfoList.splice(index , 1);
    }
    this.isSave = true;
    this.isCancel = true;
  }

  onCancel() {
    this.isCancel = false;
    this.isSave = false;
    this.deviceParamStateIconInfoList = _.cloneDeep(this.deviceparamstateicons);
  }

  onLabelChange(event) {
      this.isSave = true;
      this.isCancel = true;
  }


  getFilteredIcons(id) {
    return this.icons.filter(_icon => +_icon.iconset.id === +id);
  }

  dragStart(event, icon: IconModel) {
    this.draggedIcon = icon;
  }

  drop(event, deviceparamstateinfo: DeviceparamstateiconModel) {

    if (this.deviceparamstateicons && deviceparamstateinfo) {
      // @ts-ignore
/*      const filterediconset = this.deviceparamstateicons.filter(_iconset => _iconset.state.id === sdirparamstate.id);
      if (filterediconset && filterediconset.length !== 0) {
        filterediconset[0].icon = this.draggedIcon;
      }*/
      deviceparamstateinfo.icon = {id: this.draggedIcon.id, name: this.draggedIcon.name, iconset: this.draggedIcon.iconset};
    }
      this.isSave = true;
      this.isCancel = true;
  }

  dragEnd(event) {
    this.draggedIcon = null;
  }

  clearState(deviceparamstateinfo) {
    this.isSave = true;
    this.isCancel = true;
    if (this.deviceparamstateicons && deviceparamstateinfo) {
      deviceparamstateinfo.icon = null;
      this.cdr.detectChanges();
    }
  }

  getImageUrl(item) {
    if (item && item.id > 0) {
      return `${environment.backEndUrlPrefix + '/'}db/icon/${item.id}/img`;
    }
    return '';
  }


  exapandORcollapse(nodes, state: boolean) {
    const tmpNodes = this.treeComponent.filteredNodes || nodes;
    for (const node of tmpNodes) {
       node.expanded = state;
      if (node.children) {
        for (const cn of node.children) {
          cn.expanded = state;
        }
      }
    }
    this.treeComponent.updateSerializedValue();
    this.treeComponent.tableService.onUIUpdate(tmpNodes);
  }

  disableEvent(event) {
    event.preventDefault();
    const target = event.currentTarget;
    /*target.style.backgroundColor = 'blue';*/
    target.style.cursor = 'no-drop';
    return false;
  }

  checkDdl(event) {
    // console.log('ddl originalEvent: ', event.originalEvent);
    // console.log('ddl option: ', event.query);
  }


  public compareById(a, b) {
    if (a === null || b === null) {
      return false;
    }
    if (a && b && (a.id === undefined || b.id === undefined)) {
      return a && b && a === b;
    }
    return a && b && a.id === b.id;
  }

  onActionAdd(event?) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.isSave = true;
    this.isCancel = true;
    const s: DeviceparamstateiconModel = {id: 0, param: {id: this.cdparam.id, paramname: this.cdparam.paramname}, icon: undefined};
    this.deviceParamStateIconInfoList = this.deviceParamStateIconInfoList.concat([s]);
  }




  filterEqual(list: any[], opt: any, inx: number) {
    let ret = _.cloneDeep(list);
    return ret;
  }

  filterSelected(state, list: any[]) {
    let ret = [];
    const ids = [];
    if (this.deviceParamStateIconInfoList) {
      this.deviceParamStateIconInfoList.forEach(dps => {
        if (dps.state) {
          ids.push(dps.state.id);
        }
      });
      ret = list.filter(l => !(ids.includes(l.id)));
      if (state) {
        ret = [state, ...ret];
      }
    } else {
      ret = list;
    }
    return ret;
  }

  validation() {
    if (this.deviceParamStateIconInfoList) {
      const res = this.deviceParamStateIconInfoList.filter(dp => (!dp.state || !dp.state.id));
      if (res.length > 0) {
        return false;
      }

    }
    return true;
  }

}
